import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import * as actions from "../../../store/actions/index";
import NavBar1 from "../../Navbar1/NavBar1";
import Footer from "../../Footer/Footer";
// import "../style/style-2.6.0.css";
import "../style/minimal_style.css";
import "../style/contact.css";
function ContactUs(props) {
  let REACT_APP_CAPTCHA_ID = "6LcEnvUdAAAAAPaE3BRF8lPch1KqO4gkN7bCbg_V";
  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${REACT_APP_CAPTCHA_ID}`;
    // script.addEventListener("load", this.handleLoaded)
    document.body.appendChild(script);
  }, []);

  let [name, setName] = useState("");
  let [email, setEmail] = useState("");
  let [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!name || !email || !message) {
      return alert("Please fill All Fields");
    }
    let data = { name, email, message };
    data["subject"] = "Contact to K5-Fitness";

    window.grecaptcha.ready(function () {
      window.grecaptcha
        .execute(REACT_APP_CAPTCHA_ID, { action: "homepage" })
        .then(function (token) {
          props.contactUs(data);
        });
    });
  };

  return (
    <React.Fragment>
      <NavBar1 />
      <Footer>
        <div class="bg-light contact4 overflow-hiddedn position-relative">
          <div class="row no-gutters">
            <div class="container">
              <div class="col-lg-6 contact-box mb-4 mb-md-0">
                <div class="">
                  <h1 class="title font-weight-light text-dark mt-2">
                    Contact Us
                  </h1>
                  <form class="mt-3" onSubmit={handleSubmit}>
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="form-group mt-2">
                          <input
                            class="form-control text-dark"
                            type="text"
                            placeholder="Name"
                            onChange={(e) => setName(e.target.value)}
                            required
                          />
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="form-group mt-2">
                          <input
                            class="form-control text-dark"
                            type="Email"
                            placeholder="email address"
                            onChange={(e) => setEmail(e.target.value)}
                            required
                          />
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="form-group mt-2">
                          <textarea
                            class="form-control text-dark"
                            rows="3"
                            placeholder="Message"
                            onChange={(e) => setMessage(e.target.value)}
                            required
                          ></textarea>
                        </div>
                      </div>
                      <div class="col-lg-12 d-flex align-items-center mt-2">
                        <button
                          type="submit"
                          class="btn bg-dark text-light px-3 py-2"
                          disabled={props.loading}
                        >
                          {props.loading ? "Sending" : "Submit"}
                        </button>
                        <span class="ml-auto text-dark align-self-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-telephone pb-1 pr-2"
                            viewBox="0 0 16 16"
                          >
                            <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
                          </svg>
                          +91 084518 67144
                        </span>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="col-lg-6 right-image p-r-0">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15063.252925440307!2d72.869858!3d19.2904866!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x5dccc7f1ad028de!2sK5%20FiTNESS%20AND%20WELLNESS%20STORES%20PVT%20LTD.%20Supplement%20%7C%20Sport%20Accessiores%20%7C%20Sports%20Wear%7C%20Gym%20Equipment%20%7C%20Proteins%20bars%20%7C%20Bcaa%20%7C%20glumtime%20%7C%20L-ariginie%20%7C%20Weight%20Gain%20Supplement%20%7C%20Fat%20Burner%20%7C%20Zma%20%7C%20Tablet%20%7C%20Amino%20%7C%20Vitamin%20C!5e0!3m2!1sen!2sin!4v1641377175997!5m2!1sen!2sin"
                width="100%"
                height="538"
                frameborder="0"
                style={{ boder: "0" }}
                allowfullscreen
                data-aos="fade-left"
                data-aos-duration="3000"
              ></iframe>
            </div>
          </div>
        </div>
      </Footer>
    </React.Fragment>
  );
}
const mapStateToProps = (state) => {
  return {
    loading: state.account.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    contactUs: (data) => dispatch(actions.contactUs(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactUs);
